import { LoadingSheetDto } from "./loading-sheet-dto";


export class LoadingContainerDto {

    containerId: number;
    saleOrderId: number;
    loadingSheetReq:LoadingSheetDto[];

   
    constructor(
        containerId:number,
        saleOrderId:number,
        loadingSheetReq:LoadingSheetDto[]
    
            )
            {
           this.containerId=containerId
           this.saleOrderId=saleOrderId    
           this.loadingSheetReq=loadingSheetReq
        }
}